var render = function render(){var _vm=this,_c=_vm._self._c;return _c('book-widget-frame',{attrs:{"link":_vm.link}})
}
var staticRenderFns = []

export { render, staticRenderFns }